import {css} from 'styled-components';

export const theme = {
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1440,
  },
  primaryColor: '#304c59',
  secondaryColor: '#ffda00',
  errorColor: '#FF0000',
  headerHeight: 100,
  spaceSmall: 15,
  spaceMedium: 30,
  spaceBig: 70,
  formContainerMaxWidth: 960,
};

export const media = Object.keys(theme.breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${theme.breakpoints[label]}px) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});



// WEBPACK FOOTER //
// ./src/constants/styled.js